// BasicModal
import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useSelector, useDispatch } from 'react-redux';
import { setShowModalUser } from '../../reducers/auth.reducer';
import IconButtonClose from '../IconButtons/IconButtonClose';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'min(100% - 24px, 520px)',
    maxHeight: 'calc(100vh - 24px)',
    overflowY: 'auto',
    outline: 'none',
};

export default function BasicModal({
    children,
    open,
    onClose,
    disableClose = false,
    hideClose = false
}) {
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const modalOpen = open !== undefined ? open : auth.showModalUser;

    const handleClose = (event, reason) => {
        if (disableClose) return;

        if (onClose) {
            onClose(event, reason);
            return;
        }

        dispatch(setShowModalUser({ forceShow: false }));
    };

    return (
        <div className="basicModal">
            <Modal
                style={{ zIndex: "999920000" }}
                open={modalOpen}
                onClose={handleClose}
                disableEscapeKeyDown={disableClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="basicModal__panel">
                    {!hideClose && (
                        <div className="basicModal__close">
                            <IconButtonClose onClick={handleClose} />
                        </div>
                    )}

                    {children}
                </Box>
            </Modal>
        </div>
    );
}